module.exports = __webpack_public_path__ + "04.svg?dde27b73e779b24daa81c88cff3f7f28";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_setting/04.svg
// module id = 63
// module chunks = 0